import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  VStack,
  Image,
  Text,
  Button,
  useToast,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import * as mod from "../../url";
import { useNavigate } from "react-router-dom";
const HomeBanner = () => {
  const toast = useToast();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const SIDEBAR_WIDTH = "250px";
  const navigate = useNavigate();
  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const config = { headers: { Authorization: `${token}` } };

  // Fetch all banners
  const fetchAllBanner = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/newslatter/get/banner`,
        config
      );
      setBanners(data || []);
    } catch (error) {
      console.error(error);
      toast({
        title: "Failed to fetch banners",
        status: "error",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllBanner();
  }, []);

  // Delete banner
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      await axios.delete(
        `${mod.api_url}/api/v1/newslatter/delete/banner/${id}`,
        config
      );
      toast({
        title: "Banner deleted successfully",
        status: "success",
        duration: 3000,
      });
      fetchAllBanner();
    } catch (error) {
      console.error(error);
      toast({
        title: "Failed to delete banner",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Open update modal
  const handleUpdate = (banner) => {
    setSelectedBanner(banner);
    onOpen();
  };

  // Update banner
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", selectedBanner.title);
      formData.append("Des", selectedBanner.Des);
      formData.append("linkUrl", selectedBanner.linkUrl);
      if (selectedBanner.imgFile)
        formData.append("imgUrl", selectedBanner.imgFile);

      await axios.put(
        `${mod.api_url}/api/v1/newslatter/update/banner/${selectedBanner._id}`,
        formData,
        config
      );

      toast({
        title: "Banner updated successfully",
        status: "success",
        duration: 3000,
      });
      onClose();
      fetchAllBanner();
    } catch (error) {
      console.error(error);
      toast({
        title: "Failed to update banner",
        status: "error",
        duration: 3000,
      });
    }
  };
  const changeStatus = async (id) => {
    try {
      const { data } = await axios.put(
        `${mod.api_url}/api/v1/newslatter/update/status/${id}`,
        { config }
      );

      toast({
        title: data.message,
        status: "success",
        duration: 2000,
        isClosable: true,
      });

      fetchAllBanner();
    } catch (error) {
      console.error(error);
      toast({
        title: "Error changing status",
        description: error.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={4}>
        <Heading size="md" mb={6} backgroundColor={"blue.200"} p={4}>
          Home Banners
        </Heading>
        <Box textAlign="right" p={3}>
          <Button
            bg="blue.500"
            color="white"
            _hover={{ bg: "blue.600" }}
            onClick={() => navigate("/create-banner")} // replace with your route
          >
            Create Banner
          </Button>
        </Box>
        {loading ? (
          <Spinner size="xl" />
        ) : (
          <VStack spacing={6} align="stretch">
            {banners.length === 0 ? (
              <Text>No banners found</Text>
            ) : (
              banners.map((banner) => (
                <Box
                  key={banner._id}
                  border="1px solid lightgray"
                  borderRadius="md"
                  p={4}
                  bg="gray.50"
                >
                  {banner.imgUrl && (
                    <Image
                      src={banner.imgUrl}
                      mt={2}
                      boxSize="1000px"
                      width="100%"
                      height={"400px"}
                      //   objectFit="cover"
                      borderRadius="md"
                    />
                  )}
                  <Box textAlign={"left"}>
                    <Heading size="sm">Title-{banner.title}</Heading>
                    <Box
                      mt={2}
                      dangerouslySetInnerHTML={{ __html: banner.Des }}
                    ></Box>
                    {banner.linkUrl && (
                      <Text mt={2} color="blue.600">
                        Link: {banner.linkUrl}
                      </Text>
                    )}
                  </Box>
                  <HStack mt={3} spacing={4}>
                    <Button
                      colorScheme="yellow"
                      size="sm"
                      onClick={() => handleUpdate(banner)}
                    >
                      Update
                    </Button>
                    <Button
                      colorScheme="red"
                      size="sm"
                      onClick={() => handleDelete(banner._id)}
                    >
                      Delete
                    </Button>
                    <Button
                      colorScheme={banner.status === "Active" ? "green" : "red"}
                      size="sm"
                      onClick={() => changeStatus(banner._id)}
                    >
                      {banner.status === "Active" ? "Active" : "Inactive"}
                    </Button>
                  </HStack>
                </Box>
              ))
            )}
          </VStack>
        )}

        {/* Update Modal */}
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Update Banner</ModalHeader>
            <ModalCloseButton />
            <form onSubmit={handleUpdateSubmit}>
              <ModalBody>
                <FormControl mb={3}>
                  <FormLabel>Title</FormLabel>
                  <Input
                    value={selectedBanner?.title || ""}
                    onChange={(e) =>
                      setSelectedBanner({
                        ...selectedBanner,
                        title: e.target.value,
                      })
                    }
                  />
                </FormControl>

                <FormControl mb={3}>
                  <FormLabel>Description</FormLabel>
                  <Textarea
                    value={selectedBanner?.Des || ""}
                    onChange={(e) =>
                      setSelectedBanner({
                        ...selectedBanner,
                        Des: e.target.value,
                      })
                    }
                  />
                </FormControl>

                <FormControl mb={3}>
                  <FormLabel>Link URL</FormLabel>
                  <Input
                    value={selectedBanner?.linkUrl || ""}
                    onChange={(e) =>
                      setSelectedBanner({
                        ...selectedBanner,
                        linkUrl: e.target.value,
                      })
                    }
                  />
                </FormControl>

                <FormControl mb={3}>
                  <FormLabel>Image</FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setSelectedBanner({
                        ...selectedBanner,
                        imgFile: e.target.files[0],
                      })
                    }
                  />
                  {selectedBanner?.imgUrl && !selectedBanner?.imgFile && (
                    <Image
                      src={selectedBanner.imgUrl}
                      mt={2}
                      boxSize="150px"
                      objectFit="cover"
                      borderRadius="md"
                    />
                  )}
                  {selectedBanner?.imgFile && (
                    <Image
                      src={URL.createObjectURL(selectedBanner.imgFile)}
                      mt={2}
                      boxSize="150px"
                      objectFit="cover"
                      borderRadius="md"
                    />
                  )}
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} type="submit">
                  Save
                </Button>
                <Button onClick={onClose}>Cancel</Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default HomeBanner;
